import { render, staticRenderFns } from "./ScrollingHeader.vue?vue&type=template&id=3a1cf031&scoped=true&"
import script from "./ScrollingHeader.vue?vue&type=script&lang=js&"
export * from "./ScrollingHeader.vue?vue&type=script&lang=js&"
import style0 from "./ScrollingHeader.vue?vue&type=style&index=0&id=3a1cf031&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1cf031",
  null
  
)

export default component.exports